const filterOnlyHavingParameterSet = function(parameterPath){
    return [
        // check if there is such property in Data set
        {parameter: parameterPath, operator: 'defined', value: true},
        // check if value is not empty
        {parameter: parameterPath, operator: 'notEmpty', value: undefined}
    ];
};

const filterOnlyHavingValueEqualTo = function(parameterPath, value){
    return [
        // check if there is such property in Data set
        {parameter: parameterPath, operator: 'defined', value: true},
        // check if value is not empty
        {parameter:  parameterPath, operator: '===', value }
    ];
};

const filterOnlyHavingValueFromArray = function(parameterPath, arrayOfValues){
    return [
        // check if there is such property in Data set
        {parameter: parameterPath, operator: 'defined', value: true},
        // check if value is not empty
        {parameter: parameterPath, operator: 'IN', value: arrayOfValues}
    ];
};

const filterOnlyNotHavingValueFromArray = function(parameterPath, arrayOfValues){
    return [
        // check if there is such property in Data set
        {parameter: parameterPath, operator: 'defined', value: true},
        // check if value is not empty
        {parameter: parameterPath, operator: 'NOTIN', value: arrayOfValues}
    ];
};

const filterOnlyMatchingPredicate = function(parameterPath, predicate){
    if (typeof (predicate) !== 'function'){
        throw new TypeError('predicate must be an function')
    }
    return [
        // check if there is such property in Data set
        {parameter: parameterPath, operator: 'defined', value: true},
        // check if value is matching predicate
        {parameter: parameterPath, operator: 'function', value: predicate}
    ];
};

export {
    filterOnlyHavingParameterSet, filterOnlyHavingValueEqualTo,
    filterOnlyHavingValueFromArray, filterOnlyNotHavingValueFromArray,
    filterOnlyMatchingPredicate
};